function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7a9ac;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "contact us_icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M397.76,77.92l2.87,2,3.67,2.56,0.6,0.43,0.76,0.53c0.2,0.14.44,0.29,0.73,0.46a4.23,4.23,0,0,0,.81.38,2.23,2.23,0,0,0,.7.13h0a2.23,2.23,0,0,0,.7-0.13,4.29,4.29,0,0,0,.81-0.38c0.28-.17.53-0.32,0.73-0.46l0.76-.53,0.6-.43,6.56-4.56a6.66,6.66,0,0,0,1.71-1.72,3.71,3.71,0,0,0,.69-2.12,2.26,2.26,0,0,0-2.24-2.24H397.6a2,2,0,0,0-1.66.73,2.83,2.83,0,0,0-.58,1.82,3.28,3.28,0,0,0,.77,1.91,7,7,0,0,0,1.64,1.62h0Zm0,0",
  transform: "translate(-395.35 -71.84)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M419.08,79.42q-4.6,3.11-7,4.84-0.8.59-1.3,0.92a7.9,7.9,0,0,1-1.32.67,4,4,0,0,1-1.54.34h0a4,4,0,0,1-1.54-.34,7.94,7.94,0,0,1-1.33-.67q-0.5-.33-1.3-0.92-1.89-1.39-7-4.84a7.44,7.44,0,0,1-1.42-1.22V89.34a2.25,2.25,0,0,0,2.24,2.24h20.64a2.25,2.25,0,0,0,2.24-2.24V78.2a7.77,7.77,0,0,1-1.4,1.22h0Zm0,0",
  transform: "translate(-395.35 -71.84)"
});

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 25.13 19.74",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.e54d536b.svg";
export { ForwardRef as ReactComponent };